import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export const ProtectedRoute = ({ children, requireOwner = false, requireCompaniesAccess = false, requirePerm = null }) => {
  const { user, isOwner, canManageCompanies, hasPerm } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    // still loading auth state
    return (
      <div className="min-h-screen bg-[#0B2818] flex items-center justify-center">
        <div className="text-white font-bold">Loading…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (requireOwner && !isOwner) {
    return <Navigate to="/" replace />;
  }
  if (requireCompaniesAccess && !canManageCompanies) {
    return <Navigate to="/" replace />;
  }
  if (requirePerm && !hasPerm(requirePerm)) {
    return <Navigate to="/" replace />;
  }
  return children;
};
